<template>
  <div class="footer">
    <footer>
      <div class="container">
        <div class="footer-link">
          <div class="links">
            <div
              class="link-item"
              v-for="(item,index) in proList"
              :key="index"
              :class="{
                            'active':showProduct
                        }"
            >
              <div class="title" @click="showProduct = !showProduct">{{ item.data.title }}</div>
              <ul>
                <li v-for="(n,i) in item.children" :key="i">
                  <router-link
                    v-if="n[0].url.indexOf('http') == -1 && n[0].url.indexOf('mailto:') == -1 && n[0].url.indexOf('tel:') == -1"
                    :to="n[0].url"
                  >{{ n[0].title }}</router-link>
                  <a
                    v-else
                    href="javascript:;"
                    @click="toHref(n[0].url)"
                    :title="n[0].url | getTit"
                  >{{ n[0].title }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="about-us">
            <div class="link-item">
              <div class="title">24小时热线</div>
              <ul>
                <li v-if="pz.r4">
                  {{ pz.r4.title }}:
                  <a :href="pz.r4.url">{{ pz.r4.content }}</a>
                </li>
                <li v-if="pz.r5">
                  {{ pz.r5.title }}:
                  <a :href="pz.r5.url">{{ pz.r5.content }}</a>
                </li>
                <li v-if="pz.r6">
                  {{ pz.r6.title }}:
                  <a :href="pz.r6.url">{{ pz.r6.content }}</a>
                </li>
              </ul>
            </div>
            <div class="link-item">
              <div class="qr fr">
                <div class="btns">
                  <div
                    title="关注微信公众号"
                    data-index="0"
                    @mouseenter="ewmI = 0"
                    :class="ewmI == 0 ? 'btn active' : 'btn'"
                  >
                    <img src="../assets/images/wechat.svg" alt />
                    <img src="../assets/images/wechata.svg" alt />
                  </div>
                  <div
                    title="关注微博"
                    data-index="1"
                    @mouseenter="ewmI = 1"
                    :class="ewmI == 1 ? 'btn active' : 'btn'"
                  >
                    <img src="../assets/images/sina.svg" alt />
                    <img src="../assets/images/sinaa.svg" alt />
                  </div>
                  <div
                    title="体验支付宝小程序"
                    data-index="2"
                    @mouseenter="ewmI = 2"
                    :class="ewmI == 2 ? 'btn active' : 'btn'"
                  >
                    <img src="../assets/images/zfba.svg" alt />
                    <img src="../assets/images/zfb.svg" alt />
                  </div>
                </div>
                <div class="qr-imgs">
                  <div :class="ewmI == 0 ? 'qr-img active' : 'qr-img'">
                    <img v-if="pz.r1" :src="pz.r1.logo" alt />
                  </div>
                  <div :class="ewmI == 1 ? 'qr-img active' : 'qr-img'">
                    <img v-if="pz.r2" :src="pz.r2.logo" alt />
                  </div>
                  <div :class="ewmI == 2 ? 'qr-img active' : 'qr-img'">
                    <img v-if="pz.r3" :src="pz.r3.logo" alt />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div class="bottom">
      <div class="container">
        <div class="friend">
          <div>
            友情链接:
            <a
              target="_blank"
              v-for="(item,index) in friend"
              :key="index"
              :href="item.url"
            >{{ item.title }} {{ index < friend.length - 1?'|':'' }}</a>
          </div>
        </div>
        <p>
          <span>Copyright &#169 2019 杭州天谷信息科技有限公司版权所有.</span>
          <span>增值电信业务经营许可证浙B2-20180376号 浙ICP备11026113号 浙公网安备33010602006438号</span>
        </p>

        <div>
          <div>
            <a href="javascript:;" @click="xy = xy1;showXy = true;">{{ xy1.title }}</a> |
            <a href="javascript:;" @click="xy = xy2;showXy = true;">{{ xy2.title }}</a> |
            <a href="javascript:;" @click="xy = xy3;showXy = true;">{{ xy3.title }}</a>
          </div>
        </div>
      </div>
    </div>

    <Dialog :title="xy.title" :visible.sync="showXy" width="90%" top="80px" class="footer-dialog">
      <div v-html="xy.content"></div>
    </Dialog>
  </div>
</template>

<script>
import { Dialog } from 'element-ui'
export default {
	name: 'Footer',
	components: {
		Dialog
	},
	data() {
		return {
			xy1: {},
			xy2: {},
			xy3: {},
			xy: {},
			showXy: false,
			friend: [],
			showProduct: false,
			showQuick: false,
			showAbout: false,
			showCooperation: false,
			ewmI: 0,
			proList: [],
			pz: {}
		}
	},
	mounted() {
		this.getFriend()
		this.getPro()
		this.getPz()
		this.getXy1()
	},
	filters: {
		getTit(url) {
			if (url.indexOf('mailto:') >= 0) {
				return url.split('mailto:')[1]
			} else if (url.indexOf('tel:') >= 0) {
				return url.split('tel:')[1]
			} else {
				return ''
			}
		}
	},
	methods: {
		toHref(url) {
			window.localStorage.removeItem('esign_version')
			window.location.href = url
		},
		async getXy1() {
			var r1 = (await this.$axios.get(`/api/config/show/10009`).catch(() => {})) || {}
			var r2 = (await this.$axios.get(`/api/config/show/10010`).catch(() => {})) || {}
			var r3 = (await this.$axios.get(`/api/config/show/10011`).catch(() => {})) || {}
			this.xy1 = r1.data || {}
			this.xy2 = r2.data || {}
			this.xy3 = r3.data || {}
		},
		async getFriend() {
			var res = (await this.$axios.get('/api/friendship_link/list').catch(() => {})) || {}
			this.friend = res.data || {}
		},
		async getPro() {
			var res = (await this.$axios.get('/api/cate/list/2').catch(() => {})) || {}
			this.proList = res.data || {}
		},
		async getPz() {
			var res = (await this.$axios.get('/api/cate/list/2').catch(() => {})) || {}
			var r1 = (await this.$axios.get(`/api/config/show/10002`).catch(() => {})) || {}
			var r2 = (await this.$axios.get(`/api/config/show/10003`).catch(() => {})) || {}
			var r3 = (await this.$axios.get(`/api/config/show/10004`).catch(() => {})) || {}
			var r4 = (await this.$axios.get(`/api/config/show/10005`).catch(() => {})) || {}
			var r5 = (await this.$axios.get(`/api/config/show/10006`).catch(() => {})) || {}
			var r6 = (await this.$axios.get(`/api/config/show/10007`).catch(() => {})) || {}
			this.pz = {
				r1: r1.data || {},
				r2: r2.data || {},
				r3: r3.data || {},
				r4: r4.data || {},
				r5: r5.data || {},
				r6: r6.data || {}
			}
		}
	}
}
</script>

<style lang='less' scoped>
.footer {
	background-color: #000;
	color: #fff;

	footer {
		.footer-link {
			display: flex;
			justify-content: space-between;
			padding-top: 90px;
			padding-bottom: 55px;
		}

		.links {
			width: 63%;
			// background-color: #fff;
			display: flex;
			justify-content: space-between;
			padding-right: 20px;
			position: relative;
			padding-left: 10px;

			&::after {
				content: '';
				width: 1px;
				height: 218px;
				background-color: #505050;
				position: absolute;
				right: 0;
				top: 0;
			}
		}

		.about-us {
			width: 37%;
			padding-left: 6%;
			display: flex;
			justify-content: space-between;
			padding-right: 10px;
		}

		.link-item {
			flex: 1;

			.title {
				font-size: 16px;
				line-height: 22px;
				margin-bottom: 14px;
			}

			li {
				line-height: 36px;
				color: rgba(153, 153, 153, 1);
				font-size: 14px;

				a {
					color: rgba(153, 153, 153, 1);
					transition: all 0.4s ease-in-out;

					&:hover {
						color: #e61717;
					}
				}
			}

			.qr {
				width: 130px;

				.btns {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 17px;

					.btn {
						width: 30px;
						border-radius: 50%;
						overflow: hidden;
						cursor: pointer;
						position: relative;

						img {
							visibility: visible;
							opacity: 1;
							transition: all 0.4s ease-in-out;

							&:nth-child(2) {
								position: absolute;
								top: 0;
								left: 0;
								visibility: hidden;
								opacity: 0;
							}
						}

						&.active {
							img {
								visibility: hidden;
								opacity: 0;

								&:nth-child(2) {
									visibility: visible;
									opacity: 1;
								}
							}
						}
					}
				}
			}

			.qr-imgs {
				position: relative;

				.qr-img {
					position: absolute;
					top: 0;
					left: 0;
					opacity: 0;
					visibility: hidden;
					transition: all 0.4s ease-in-out;

					&.active {
						visibility: visible;
						opacity: 1;
					}

					&::before {
						content: '';
						position: absolute;
						width: 0;
						height: 0;
						top: -8px;
						border: 7px solid transparent;
						border-top: 0;
						border-bottom: 8px solid #fff;
					}

					&:nth-child(1) {
						position: relative;
					}

					&:nth-child(1)::before {
						left: 8px;
					}

					&:nth-child(2)::before {
						left: 0;
						right: 0;
						margin: auto;
					}

					&:nth-child(3)::before {
						right: 8px;
					}
				}
			}
		}
	}

	.bottom {
		text-align: center;
		color: #666;
		font-size: 12px;
		line-height: 31px;
		background: rgba(17, 17, 17, 1);
		padding: 0 12px;
		padding-top: 17px;
		padding-bottom: 30px;

		a {
			color: #666;
			transition: all 0.4s ease-in-out;
			&:hover {
				color: #fff;
			}
		}

		span {
			word-break: keep-all;
		}
	}
}

@media only screen and (max-width: 768px) {
	.footer {
		padding-bottom: 50px;
		footer {
			.footer-link {
				display: block;
				padding: 30px 0;

				.links {
					display: none;
				}

				.about-us {
					width: 100%;
					font-size: 14px;
					padding: 0;
					text-align: center;
					.link-item {
						text-align: left;
					}

					.title {
						font-size: 18px;
						font-weight: 700;
					}

					.qr {
						width: 100px;
						margin: 0px auto 0;
						float: none;

						.wechat {
							padding-left: 24px;
							background: url('../assets/images/wechat.svg') no-repeat 6px center;
							background-size: 14px auto;
							line-height: 30px;
							margin-bottom: 5px;
							font-size: 14px;
						}
					}
				}
			}
		}

		.bottom {
			// margin: 0 -5%;
			padding: 18px 5%;
			line-height: 20px;
			font-size: 12px;
		}

		.friend {
			/*display: none;*/
		}
	}
}
</style>
